import { AxiosResponse, AxiosRequestConfig } from 'axios';

import client from 'api/client';
import { Application } from '../models/response';
import { getActingProfileUserId } from 'utils/selectedAccount';

export function get(
    candidateId: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<Application[]>> {
    // Spouse switch uses /{id}; self and B2B keep the caller-provided candidate.
    const id = getActingProfileUserId() ?? candidateId;
    return client.get<Application[]>(`/applications/${id}`, customConfig);
}
